import { Reducer, Action } from 'redux'
import {
  FETCH_CHILD_USERS_ACTION_TYPES,
  CREATE_CHILD_USER_ACTION_TYPES,
  EDIT_CHILD_USER_ACTION_TYPES,
  DELETE_CHILD_USER_ACTION_TYPES,
} from 'utils/actions/user'
import { IChildUser } from 'apps/user/types/user'

const {
  FETCH_CHILD_USERS_FAILURE,
  FETCH_CHILD_USERS_REQUEST,
  FETCH_CHILD_USERS_SUCCESS,
} = FETCH_CHILD_USERS_ACTION_TYPES

const {
  CREATE_CHILD_USER_FAILURE,
  CREATE_CHILD_USER_REQUEST,
  CREATE_CHILD_USER_SUCCESS,
} = CREATE_CHILD_USER_ACTION_TYPES

const {
  EDIT_CHILD_USER_FAILURE,
  EDIT_CHILD_USER_REQUEST,
  EDIT_CHILD_USER_SUCCESS,
} = EDIT_CHILD_USER_ACTION_TYPES

const {
  DELETE_CHILD_USER_FAILURE,
  DELETE_CHILD_USER_REQUEST,
  DELETE_CHILD_USER_SUCCESS,
} = DELETE_CHILD_USER_ACTION_TYPES

interface IChildUsersFetchAction {
  type: string
  error?: string
  payload: {
    users: IChildUser[]
  }
}

interface IChildUserAction {
  type: string
  error?: string
  payload: {
    user?: IChildUser
    requestData: {
      group?: string
    }
  }
}

type ActionType = Action<string> | IChildUsersFetchAction | IChildUserAction

export interface IChildUserState {
  fetching: boolean
  error?: string
  users: IChildUser[]
}

const defaultState = {
  fetching: false,
  error: '',
  users: [],
}

const replaceOrAddUser = (users: IChildUser[], user: IChildUser) => {
  const newUsersList = [...users]

  const userIndex = users.findIndex(item => item.id === user.id)
  if (userIndex !== -1) {
    newUsersList[userIndex] = user
  } else {
    newUsersList.push(user)
  }

  return newUsersList
}

const deleteUser = (users: IChildUser[], group: string) => {
  const userId = group.split('/')[1]

  const newUsersList = users.filter(user => String(user.id) !== userId)

  return newUsersList
}

const childUsersReducer: Reducer<IChildUserState, ActionType> = (state = defaultState, action) => {
  switch (action.type) {
    case CREATE_CHILD_USER_REQUEST:
    case EDIT_CHILD_USER_REQUEST:
    case DELETE_CHILD_USER_REQUEST:
    case FETCH_CHILD_USERS_REQUEST: {
      return {
        ...state,
        fetching: true,
        error: '',
      }
    }
    case FETCH_CHILD_USERS_FAILURE: {
      const { error } = action as IChildUsersFetchAction
      return {
        ...state,
        fetching: false,
        error: error || 'An error occurred fetching associated user accounts',
      }
    }
    case FETCH_CHILD_USERS_SUCCESS: {
      const {
        payload: { users },
      } = action as IChildUsersFetchAction
      return {
        ...state,
        fetching: false,
        error: '',
        users,
      }
    }
    case CREATE_CHILD_USER_SUCCESS:
    case EDIT_CHILD_USER_SUCCESS: {
      const {
        payload: { user },
      } = action as IChildUserAction

      return {
        ...state,
        fetching: false,
        users: replaceOrAddUser(state.users, user as IChildUser),
      }
    }
    case DELETE_CHILD_USER_SUCCESS: {
      const {
        payload: {
          requestData: { group },
        },
      } = action as IChildUserAction

      return {
        ...state,
        fetching: false,
        users: deleteUser(state.users, group as string),
      }
    }
    case CREATE_CHILD_USER_FAILURE:
    case EDIT_CHILD_USER_FAILURE:
    case DELETE_CHILD_USER_FAILURE: {
      const { error } = action as IChildUserAction

      return {
        ...state,
        fetching: false,
        error,
      }
    }
    default:
      return state
  }
}

export default childUsersReducer
